/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'header';
const componentName = 'avi-main-header-user-menu';
const prefix = `${moduleName}.${componentName}`;

export const myAccountLabel = `${prefix}.myAccountLabel`;
export const aboutLabel = `${prefix}.aboutLabel`;
export const aviApiDocumentationLabel = `${prefix}.aviApiDocumentationLabel`;
export const customerPortalLabel = `${prefix}.customerPortalLabel`;
export const signOutLabel = `${prefix}.signOutLabel`;

export const ENGLISH = {
    [myAccountLabel]: 'My Account',
    [aboutLabel]: 'About VMware Avi Load Balancer',
    [aviApiDocumentationLabel]: 'Avi API Documentation',
    [customerPortalLabel]: 'Customer Portal',
    [signOutLabel]: 'Sign Out',
};
